import { PageRequest } from '@/core/request/PageRequest';

export enum InvoiceCarrierPersonType {
  natural = 'NATURAL',
  legal = 'LEGAL',
}

export interface InvoiceCarrier extends InvoiceCarrierRequest {
  id: number;
  address: InvoiceCarrierAddressId;
}

export interface InvoiceCarrierRequest {
  id: number;
  address: InvoiceCarrierAddress;
  cpfCnpj: string;
  name: string;
  observation: string;
  personType: InvoiceCarrierPersonType;
  stateRegistration: string;
  active: boolean;
}

export type InvoiceCarrierUpdateRequest = InvoiceCarrierRequest;

export interface InvoiceCarrierAddress {
  cityId: number;
  complement: string;
  district: string;
  number: string;
  street: string;
  zip: string;
}

interface InvoiceCarrierAddressId extends InvoiceCarrierAddress {
  id: number;
}

export interface InvoiceCarrierListRequest extends Omit<PageRequest, 'order'> {
  cpfCnpj?: string;
  name?: string;
}
